import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header/Header';
import Footer from '../../../components/Footer/Footer';
import ComponentPageTitle from '../../../components/PageTitle';
import CenteredContainer from '../../../components/CenteredContainer';
import PageName from '../../../components/PageName';
import Spacer from '../../../components/Spacer';
import CircleNum from '../mini_components/CircleNum';
import ComponentProductHeader from '../mini_components/ComponentProductHeader';
import { OpenInNewOutlined } from '@mui/icons-material';
import SpanBold from '../../../components/SpanBold';

import { workData } from '../WorkData';
import ProductPageH2 from '../mini_components/ComponentProductPageH2';
import BeRehearsal1 from '../../../assets/images/product_pages/berehearsal/berehearsal_1.png'
import BeRehearsal2 from '../../../assets/images/product_pages/berehearsal/berehearsal_2.png'
import BeRehearsal3 from '../../../assets/images/product_pages/berehearsal/berehearsal_3.png'
import BeRehearsal4 from '../../../assets/images/product_pages/berehearsal/berehearsal_4.png'
import BeRehearsal5 from '../../../assets/images/product_pages/berehearsal/berehearsal_5.png'
import BeRehearsal6 from '../../../assets/images/product_pages/berehearsal/berehearsal_6.png'
import BeRehearsal7 from '../../../assets/images/product_pages/berehearsal/berehearsal_7.png'
import BeRehearsal8 from '../../../assets/images/product_pages/berehearsal/berehearsal_8.png'



const ProductBeRehearsal = () => {
    const sushiwariData = workData.find(item => item.title === "BeRehearsal.");
    const [isDesktop, setIsMobile] = useState(window.innerWidth > 767);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth > 767);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    PageName("BeRehearsal. - 制作物");

    return (<>
        <Header />
        <CenteredContainer>
        <ComponentPageTitle title="BeRehearsal. - 制作物" />

        {/* ================================================= 冒頭部分 ================================================= */}
        <ComponentProductHeader isDesktop={isDesktop} data={sushiwariData} />
        {/* ========================================================================================================== */}


        {/* =============================================== BeReal.とは ================================================ */}
        <ProductPageH2>BeReal.とは</ProductPageH2>
        <ul>
            <p>
                <a
                    href='https://bereal.com/ja/'
                    style={{
                        backgroundColor: 'black',
                        padding: '5px 10px',
                        borderRadius: '10px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginRight: '4px',
                        marginBottom: '2px'
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    BeReal.<OpenInNewOutlined style={{ color: 'white', fontSize: '18px', marginLeft: '5px' }} />
                </a>
                とは、<SpanBold>1日に1度ランダムな時間</SpanBold>に通知が届き、<SpanBold>2分以内</SpanBold>に内側と外側のカメラで同時に撮影した<SpanBold>加工なしの日常の写真</SpanBold>を友達と共有する、Z世代を中心に世界中で人気なSNSです。
            </p>

            <Spacer height={20} />
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px',
                margin: '0 auto',
                width: '90%'
            }}>
                <iframe width="290" height="430" src="https://www.youtube.com/embed/wm7dfls04D8" title="BeRealは&quot;ビーリアル&quot;じゃありません。#大川優介 #yusukeokawa #apple #iphone #bereal #smartphone #cameraap #sns #genz" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <Spacer width={10} />
                <div style={{ width: '55%' }}>
                    <p style={{ margin: '15px 0 30px 0' }}><CircleNum>←</CircleNum> BeReal.について分かりやすく解説している動画</p>
                    <p style={{ margin: '20px 0 30px 0' }}>この動画で言及されていた通り、BeReal.は正しくは「ビリール」と呼ぶのですが、私の周りのユーザーは私も含め、全員「ビーリアル」と呼んでいます。</p>
                </div>
            </div>
        </ul>
        {/* ========================================================================================================== */}


        {/* ============================================== 解決したい課題 =============================================== */}
        <ProductPageH2>解決したい課題</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>友人と Bereal. について話している際に、次の BeReal. の仕様に <SpanBold>少し不便</SpanBold> を感じているという話題が出ました：</p>
            <Spacer height={30} />
            <ol style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                padding: 0,
                margin: 0
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '20px',
                    margin: '0 auto',
                    width: '90%'
                }}>
                    <div>
                        <img src={BeRehearsal1} alt="BeReal. 2回の再撮影" style={{ width: '260px', height: 'auto' }} />
                        <p style={{ margin: '5px 0', textAlign: 'center' }}><CircleNum>↑</CircleNum>再撮影時の表示</p>
                    </div>
                    <Spacer width={10} />
                    <div style={{ width: '55%' }}>
                        <p style={{ marginBottom: '16px' }}>BeReal.では、シェアする画像を再撮影することが可能なのですが、再撮影を行うと他のユーザーに<SpanBold>「n回の再撮影」</SpanBold>と表示されてしまいます。</p>
                        <p style={{ marginBottom: '16px' }}>このように表示されてしまうと、他のユーザーはあまり気にしていないというものの、やはり自分の中では気になるといった話題となり、<SpanBold>「やっぱり一発で撮りたい！」</SpanBold>という意見で満場一致しました。</p>
                        <p>そこで、撮影のリハーサルアプリを作れば、この課題を解決できるのではないかと考え、本アプリを開発するきっかけとなりました。</p>
                    </div>
                </div>
            </ol>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 機能 =================================================== */}
        <ProductPageH2>機能</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>次の3つの機能・要素によって、ユーザーが快適にBeReal.を利用することをサポートします：</p>

            <Spacer height={20} />
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>撮影リハーサル　</span>BeReal.のデザインに近づけているため、同じ操作性で撮影のリハーサルを行うことができます。
                <p style={{ marginLeft: '80px' }}>
                    <img src={BeRehearsal2} alt="機能1" style={{ width: '100%', maxWidth: '240px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>撮影後に本家を開く　</span>撮影後の確認画面から BeReal. のアプリを開くことができ、スムーズな遷移が可能です。
                <p style={{ marginLeft: '80px' }}>
                    <img src={BeRehearsal3} alt="機能2" style={{ width: '100%', maxWidth: '240px', margin: '10px 0' }} />
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>3</CircleNum><span style={{fontWeight: 'bold'}}>多言語対応　</span>アプリ言語はデフォルトの日本語だけでなく、次の8ヶ国語に対応しています。
                <p style={{ marginLeft: '80px' }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '20px',
                        width: '90%',
                        marginTop: '10px'
                    }}>
                        <img src={BeRehearsal4} alt="機能2" style={{ width: '100%', maxWidth: '240px' }} />
                        <Spacer width={10} />
                        <div style={{ width: '55%' }}>
                            <ul>
                                <li style={{ marginBottom: '5px' }}>英語 (English)</li>
                                <li style={{ marginBottom: '5px' }}>フランス語 (Français)</li>
                                <li style={{ marginBottom: '5px' }}>ドイツ語 (Deutsch)</li>
                                <li style={{ marginBottom: '5px' }}>韓国語 (한국어)</li>
                                <li style={{ marginBottom: '5px' }}>中国語 (中文-簡体字)</li>
                                <li style={{ marginBottom: '5px' }}>スペイン語 (Español)</li>
                                <li style={{ marginBottom: '5px' }}>イタリア語 (Italiano)</li>
                                <li>ポルトガル語 (Português)</li>
                            </ul>
                            <p style={{ marginTop: '15px' }}>なお上記8ヶ国語は、開発者のネイティブ言語である日本語を、Google翻訳を用いて各言語に翻訳しているため、正確な訳文ではない可能性があります。</p>
                        </div>
                    </div>
                </p>
            </p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================== 工夫点 ================================================== */}
        <ProductPageH2>ユーザーの使いやすさのために工夫した点</ProductPageH2>
        <ul style={{ color: 'var(--common-main-color)', fontSize: '110%' }}>
            <p>ユーザーの使いやすさのために、次のn点を工夫しました。</p>

            <Spacer height={20} />
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>本家と同じ操作性　</span>なるべく本家と同じ操作性でユーザーが使えるよう、UI/UXを設計しました。
                <p style={{ marginLeft: '30px', marginTop: '20px', fontSize: '16px' }}>例：撮影画面 <span style={{ fontSize: '13px' }}>（最新バージョンのBeReal.のUIに追いついていませんが、おおむね同じ操作性で使用することができます）</span></p>
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                        <img src={BeRehearsal5} alt="工夫点1-1" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                        ↑ BeReal.
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px' }}>
                        <img src={BeRehearsal6} alt="工夫点1-2" style={{ width: '100%', maxWidth: '200px', margin: '10px 0' }} />
                        ↑ BeRehearsal.
                    </div>
                </p>
            </p>

            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>スタート画面スキップ　</span>起動時に瞬時に撮影画面の表示を可能にさせ、ユーザー体験向上に努めました。
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <img src={BeRehearsal7} alt="工夫点2" style={{ width: '100%', maxWidth: '320px', margin: '10px 0' }} />
                </p>
            </p>
            <Spacer height={20} />
            <p>
                <CircleNum>3</CircleNum><span style={{fontWeight: 'bold'}}>左利きモード　</span>左利きのユーザーが快適に使用できるよう、ボタンの配置などを反転させる機能を実装しました。
                <p style={{ marginLeft: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
                    <img src={BeRehearsal8} alt="工夫点3" style={{ width: '100%', maxWidth: '320px', margin: '10px 0' }} />
                </p>
            </p>
        </ul>
        {/* ========================================================================================================== */}


        {/* ================================================ 今後の展望 ================================================ */}
        <ProductPageH2>今後の展望</ProductPageH2>
        <ul>
            <p>
                <CircleNum>1</CircleNum><span style={{fontWeight: 'bold'}}>Android版への対応　</span>最近 Google Pixel 9a を購入したため、Android版への対応を行う予定です。
            </p>
            <Spacer height={20} />
            <p>
                <CircleNum>2</CircleNum><span style={{fontWeight: 'bold'}}>最新バージョンのデザインへの対応　</span>BeReal.最新バージョンのデザインに追いつくよう、UI/UXの改善を行う予定です。
            </p>
        </ul>
        {/* ========================================================================================================== */}


        </CenteredContainer>
        <Footer />
    </>);
};



export default ProductBeRehearsal;